import React from 'react'

const ClockIcon = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M7.99902 2.66602C10.9445 2.66602 13.332 5.0535 13.332 7.99902C13.332 10.9445 10.9445 13.332 7.99902 13.332C5.0535 13.332 2.66602 10.9445 2.66602 7.99902C2.66602 5.0535 5.0535 2.66602 7.99902 2.66602ZM7.99902 14.666C11.6809 14.666 14.666 11.6809 14.666 7.99902C14.666 4.31713 11.6809 1.33203 7.99902 1.33203C4.31713 1.33203 1.33203 4.31713 1.33203 7.99902C1.33203 11.6809 4.31713 14.666 7.99902 14.666ZM8.66602 7.72266V3.99902H7.33203V8.27539L7.52734 8.4707L9.86133 10.8037L10.332 10.332L10.8037 9.86133L8.66602 7.72266Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default ClockIcon
